import * as React       from 'react';
import Typography       from '@mui/material/Typography';
import Box              from '@mui/material/Box';
import IconButton       from '@mui/material/IconButton';
import {
    FUNEXPECTED_APPSTORE,
    FUNEXPECTED_GOOGLE_PLAY,
    STUDENT_GUIDE_1,
    STUDENT_GUIDE_2,
    STUDENT_GUIDE_3,
}                       from 'config/config';
import {
    ReactComponent as GooglePlayButton
}                       from 'images/GooglePlayButton.svg';
import{
    ReactComponent as AppStoreButton
}                       from 'images/AppStoreButton.svg';

const StudentGuide = () => {
    return(
        <>
            {/* Real <ol>: numbers hang as markers, wrapped lines stay indented. */}
            <Box component="ol" sx={{ alignSelf: 'flex-start', m: 0, pl: 3 }}>
                {[STUDENT_GUIDE_1, STUDENT_GUIDE_2, STUDENT_GUIDE_3].map((step) => (
                    <Typography key={step} component="li" sx={{ '& + &': { mt: 1 } }}>
                        {step}
                    </Typography>
                ))}
            </Box>
            <Box
                display='flex'
                sx={{justifyContent: 'center', width: '100%', gap: 2, pt: 8}}
            >
                <IconButton
                    disableRipple
                    sx={{padding: 0}}
                    style={{ backgroundColor: 'transparent' }}
                    href={FUNEXPECTED_GOOGLE_PLAY} target="_blank"
                >
                    <GooglePlayButton width={188} height={56}/>
                </IconButton>
                <IconButton
                    disableRipple
                    sx={{padding: 0}}
                    style={{ backgroundColor: 'transparent' }}
                    href={FUNEXPECTED_APPSTORE} target="_blank"
                >
                    <AppStoreButton width={173} height={56}/>
                </IconButton>
            </Box>
        </>
    );
};

export default StudentGuide;